import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { REVIEWS } from "../data/site";

const easeOut = [0.16, 1, 0.3, 1];

export default function Reviews() {
  return (
    <section id="reviews" className="scroll-mt-24 py-20 md:py-24" data-testid="reviews-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mx-auto max-w-2xl text-center md:mx-0 md:text-left">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, ease: easeOut }}
          >
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-blush-700">
              Happy Parents
            </p>
            <h2 className="mt-3 font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl">
              Reviews that make us blush
            </h2>
            <div className="mt-4 inline-flex items-center gap-1.5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-5 w-5 fill-butter-500 text-butter-500" />
              ))}
              <span className="ml-2 text-sm font-semibold text-muted">
                Loved by parents everywhere
              </span>
            </div>
          </motion.div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {REVIEWS.map((r, i) => (
            <motion.figure
              key={r.parent}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.55, ease: easeOut, delay: i * 0.09 }}
              data-testid={`review-card-${i}`}
              className="relative flex h-full flex-col rounded-[28px] border border-lav-100 bg-white p-7 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:shadow-lav-100"
            >
              <Quote className="h-7 w-7 text-blush-300" />
              <div className="mt-4 flex items-center gap-1">
                {[...Array(r.stars)].map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-butter-500 text-butter-500" />
                ))}
              </div>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-ink/80">
                "{r.comment}"
              </blockquote>
              <figcaption className="mt-5 border-t border-lav-100 pt-4">
                <p className="font-display text-base font-semibold text-ink">
                  {r.parent}
                  <span className="ml-2 text-xs font-semibold text-mint-600">
                    {r.role}
                  </span>
                </p>
                <p className="mt-1 text-xs text-muted">Bought: {r.product}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
